module.exports = __webpack_public_path__ + "img/xqtx-banner1.5045206d.png";